import styled from "styled-components";

export const WishListTitleContainer = styled.h1 `
    font-weight: 550;
    font-size: 1.2rem;
    line-height: auto;
    color: ${props => props.theme.colors.typography1.pure};
    margin-bottom:32px;
    padding-left: 6px;

    @media(min-width: 480px) {
        font-size: 1.5rem;
        line-height: 60px;
    }

    @media(min-width: 768px) {
        font-size: 1.375rem;
        line-height: 27px;
        margin-bottom:28px;
    }
`